import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const getAlertTheme = (icon = "info") => {
  const themes = {
    success: "#16a34a",
    error: "#dc2626",
    warning: "#f59e0b",
    info: "#2563eb",
    question: "#7c3aed",
  };

  return themes[icon] || themes.info;
};

const inferIcon = (message = "") => {
  const text = String(message).toLowerCase();
  if (text.includes("success") || text.includes("approved") || text.includes("submitted") || text.includes("sent")) return "success";
  if (text.includes("error") || text.includes("failed") || text.includes("incorrect") || text.includes("invalid")) return "error";
  if (text.includes("required") || text.includes("fill") || text.includes("remark")) return "warning";
  return "info";
};

export const sweetAlert = (message, options = {}) => {
  const icon = options.icon || inferIcon(message);
  const forceModal = options.forceModal === true;

  return Swal.fire({
    toast: forceModal ? false : true,
    position: forceModal ? (options.position || "center") : "top-end",
    icon,
    title: options.title || (icon === "success" ? "Success" : icon === "error" ? "Error" : icon === "warning" ? "Attention" : "Notice"),
    text: String(message || ""),
    timer: options.timer ?? 2800,
    timerProgressBar: true,
    showConfirmButton: forceModal ? (options.showConfirmButton ?? true) : false,
    confirmButtonColor: getAlertTheme(icon),
    didOpen: (toast) => {
      if (!forceModal) {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      }
    },
  });
};

export const sweetConfirm = async (message, options = {}) => {
  const result = await Swal.fire({
    icon: options.icon || "warning",
    title: options.title || "Are you sure?",
    text: String(message || ""),
    showCancelButton: true,
    confirmButtonText: options.confirmButtonText || "Yes",
    cancelButtonText: options.cancelButtonText || "Cancel",
    confirmButtonColor: options.confirmButtonColor || "#dc2626",
    cancelButtonColor: options.cancelButtonColor || "#64748b",
    reverseButtons: true,
  });

  return result.isConfirmed;
};

export const installGlobalSweetAlerts = () => {
  if (typeof window === "undefined" || window.__sweetAlertsInstalled) return;

  window.__sweetAlertsInstalled = true;
  window.nativeAlert = window.alert;
  window.alert = (message) => {
    sweetAlert(message);
  };
};
